export default __webpack_public_path__ + "static/media/header_bg.b28c6edf.png";